import React from 'react';
import { Copy, Flex } from '@grubhubprod/gh-cookbook-react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';
import { IErrorResponse } from 'src/utilities/shared-types';
import {
  DEFAULT_ERROR_MESSAGE,
  SdkErrorResponse,
} from 'src/utilities/notifications';

export type DataTableErrorProps = {
  children?: (error: IErrorResponse | SdkErrorResponse) => React.ReactNode;
};

export const DataTableError: React.FC<DataTableErrorProps> = ({ children }) => {
  const { error, isError } = useDataTableContext();

  if (!isError) {
    return null;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      minHeight="100px"
    >
      {children?.(error) ?? (
        <Copy variant="body" color="primaryText">
          {DEFAULT_ERROR_MESSAGE}
        </Copy>
      )}
    </Flex>
  );
};
